export default __webpack_public_path__ + "static/media/logo.b66c15a5.png";